var o = [
  "http:",
  "https:",
  "mailto:",
  "tel:"
], a = "https://same-origin-probe.invalid", c = (t) => {
  if (t.startsWith("/")) try {
    return new URL(t, a).origin === a;
  } catch {
    return !1;
  }
  try {
    const e = new URL(t);
    return o.includes(e.protocol);
  } catch {
    return !1;
  }
}, p = (t) => {
  if (!t || t.trim().length === 0) return;
  if (c(t)) return t;
  if (t.startsWith("/")) return;
  const e = `https://${t}`;
  return c(e) ? e : void 0;
}, h = /https?:\/\/[^\s<>[\]]+[^\s<>[\].,;:!?)]/g, l = (t) => {
  const e = [];
  let n = 0;
  for (const s of t.matchAll(h)) {
    const i = s[0], r = s.index;
    r > n && e.push({
      type: "text",
      content: t.slice(n, r)
    }), e.push({
      type: "link",
      content: i
    }), n = r + i.length;
  }
  return n < t.length && e.push({
    type: "text",
    content: t.slice(n)
  }), e;
};
export {
  p as n,
  l as t
};
